import { GET_ALL_USER_SUCCESS, SET_CURRENT_USER, SET_CURRENT_ADMIN, GET_USER_INFO_SUCCESS, GET_USER_INFO_LOADING, USER_LOGOUT, USER_CHANGE_PASSWORD_SUCCESS } from '../actions/types';

const initialState = {
  loading: false,
  users: [],
  user: {},
  result: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ALL_USER_SUCCESS:
      return {
        ...state,
        users: action.payload,
        loading: false
      };
    default:
      return state;
  }
}
